const productionEndpoints = {
    apiFeauturedBlock: "rest/V1/mr-menu/featured-block/"
};

const config = {
    ...productionEndpoints,
};

export default config;
